import qs from "qs";
import axios from "axios";
import { URL } from "../../../constants/Constants";

/**
 * Obtiene información completa del reporte diario
 * @param {number} currentScreenId - ID de la pantalla actual
 * @param {string} typeConnect - Tipo de conexión
 * @param {string} fecha - Fecha de inicio
 * @param {string} fechaFin - Fecha de fin
 * @param {string} departamento - Departamento
 * @param {string} mo - Manufacturing Order
 * @param {string} po - Purchase Order
 * @param {string} referencia - Referencia
 * @param {string} selectedOperario - Operario seleccionado
 * @returns {Promise<Array|false>} Datos del reporte diario o false si hay error
 */
export const getFullInfoDailyReport = async (
  currentScreenId,
  typeConnect,
  fecha,
  fechaFin,
  departamento,
  mo,
  po,
  referencia,
  selectedOperario
) => {
  const newTime = {
    query_type: currentScreenId,
    action: typeConnect,
    fecha: fecha,
    fechaFin: fechaFin,
    departamento: departamento,
    mo: mo,
    po: po,
    referencia: referencia,
    selectedOperario: selectedOperario,
  };

  try {
    const response = await axios.post(URL, qs.stringify(newTime));

    if (response.data.status === "ok") {
      console.log("Carga de daily report correcta");
      return response.data.data;
    } else {
      console.log("Error en la carga de daily report");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Obtiene datos para exportar a Excel
 * @param {string} type - Tipo de pantalla
 * @param {string} typeConnect - Tipo de conexión
 * @param {number} currentScreenId - ID de la pantalla actual
 * @returns {Promise<Object|false>} Datos de respuesta o false si hay error
 */
export const getDatosExcel = async (type, typeConnect, currentScreenId) => {
  const queryData = {
    screen: type,
    action: typeConnect,
    query_type: currentScreenId,
    proceso_tipo: "Excel",
  };

  try {
    const response = await axios.post(URL, qs.stringify(queryData));

    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};
